import * as React from 'react';

import { cssClass } from '~src/style';

export type TextTableCellProps = Readonly<{
  testId: string;
  text: string;
  isTextItalicized: boolean;
}>;

export function TextTableCell(props: TextTableCellProps) {
  const { testId, text, isTextItalicized } = props;
  const textTableCellClass = cssClass('text-table-cell', 'span', {
    fontStyle: isTextItalicized ? 'italic' : undefined,
  });
  return (
    <td>
      <span className={textTableCellClass + ' tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={testId}>
        {text}
      </span>
    </td>
  );
}


